module.exports = __webpack_public_path__ + "img/edit-license.06701fe8.svg";